module.exports = __webpack_public_path__ + "static/media/development.5388a333.jpg";